import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';
import { Observable } from 'rxjs';
import { OnDisplayService } from '../ondisplay/onDisplay.service';

@Injectable({
	providedIn: 'root',
})
export class CampaignsService {
	user: any;
	constructor(
		private http: HttpClient,
		private utils: UtilsService,
		private onDisplaySrv: OnDisplayService,
	) {}

	getCallerCampaigns(userId: number) {
		const url = `${environment.api}caller/campaigns/${userId}/available_campaigns`;
		return this.http.get(url);
	}
	getCampaignInfoCalendar(campaign_id: any): Observable<any> {
		const url: string = `${environment.api}campaign/${campaign_id}/get_campaign_info_by_id`;
		return this.http.get(url);
	}
	getRandomProspect(campaign_id: any, caller_id: any, primary_phone = ''): Observable<any> {
		var formData: any = new FormData();
		formData.append('caller_id', caller_id);
		formData.append('campaign_id', campaign_id);
		formData.append('primary_phone', primary_phone);
		const url: string = `${environment.api}caller/campaigns/get_random_prospect`;
		return this.http.post(url, formData);
	}

	getCampaignsForSelect(isActive: string) {
		const url = `${environment.api}utilidades/${isActive}/get_campaigns_for_select`;
		return this.http.get(url);
	}

	getCampaignAndInfoById(id: any) {
		const url = `${environment.api}campaign/${id}/get_campaign_and_info`;
		return this.http.get(url);
	}

	getSuppliedTime(campaign_id: number, start_date: string) {
		return this.onDisplaySrv.getTimeSupplied(campaign_id, start_date);
	}

	getCallbacksCount(campaignId: number, userId: number): Observable<any> {
		const formData: any = new FormData();
		formData.append('campaign_id', campaignId);
		formData.append('user_id', userId);
		const url: string = `${environment.api}campaigns/get_callbacks_count`;
		return this.http.post(url, formData);
	}

	getLastNotes(prospectId: number) {
		const formData = new FormData();
		formData.append('prospect_id', prospectId.toString());
		const url = `${environment.api}campaigns/get_last_notes`;
		return this.http.post<any>(url, formData);
	}

	getCampaignCallSheet(campaign_id) {
		const url = `${environment.api}campaign/${campaign_id}/get_call_sheet`;
		return this.http.get(url);
	}
}
